import { useEffect, useMemo, useState } from 'react';

const losAngelesTimeZone = 'America/Los_Angeles';

function formatLosAngelesTime(date: Date) {
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: '2-digit',
    timeZone: losAngelesTimeZone,
    timeZoneName: 'short',
  })
    .format(date)
    .replace(/\s?(AM|PM)\s?/, ' ');
}

export function LosAngelesClock() {
  const [now, setNow] = useState(() => new Date());
  const time = useMemo(() => formatLosAngelesTime(now), [now]);

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), 1000 * 30);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <time
      className="fixed right-4 z-30 hidden text-right text-base font-light text-black md:block md:text-xl"
      style={{ bottom: 'calc(env(safe-area-inset-bottom) + 1rem)' }}
      dateTime={now.toISOString()}
    >
      {time}
    </time>
  );
}
